import { useAppStore } from './store';
import MainLayout from './layouts/MainLayout';
import DashboardPage from './pages/DashboardPage';
import MaterialsPage from './pages/MaterialsPage';
import PreviewPage from './pages/PreviewPage';
import ExercisesPage from './pages/ExercisesPage';
import TestsPage from './pages/TestsPage';
import MistakesPage from './pages/MistakesPage';
import DifficultyPage from './pages/DifficultyPage';
import EssayPage from './pages/EssayPage';
import FlashcardsPage from './pages/FlashcardsPage';

const moduleComponents: Record<string, React.FC> = {
  dashboard: DashboardPage,
  materials: MaterialsPage,
  preview: PreviewPage,
  exercises: ExercisesPage,
  tests: TestsPage,
  mistakes: MistakesPage,
  difficulty: DifficultyPage,
  essay: EssayPage,
  flashcards: FlashcardsPage,
};

function App() {
  const { activeModule } = useAppStore();
  const PageComponent = moduleComponents[activeModule] || DashboardPage;

  return (
    <MainLayout>
      <PageComponent />
    </MainLayout>
  );
}

export default App;
